<template>
  <div class="menu-group">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.menu-group {
  padding: 0.5rem 1rem;

  & + & {
    border-top: 1px solid var(--color-border-light);
  }
}
</style>
